import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';

import { FaCheck, FaCar } from 'react-icons/fa';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.alt2} />
        </div>
        <div className="sub-image two">
          <div className="experience">
            <div className='car-icon'><FaCar /></div>
            <div className="text">
              <span>{image.experience.years}</span> <p>{image.experience.title}</p>
            </div>
          </div>
          <img src={image.src3} alt={image.alt3} />
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        <p>{description}</p>

        {/* Key Features */}
        <div className="about-features">
          {points.map((point, index) => (
            <div className="item" key={index}>
              <div className="icon"><FaCheck /></div>
              <span>{point}</span>
            </div>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;